import React from "react"
import Head from "next/head"
import FlexibleData from "../../lib/flexibleData"
import { getCareerPagePaths } from "../../lib/api"
import { getJob } from "../../lib/careers"
import FlexiblePage from "../../templates/flexible/template"

export async function getStaticPaths() {
  const slugs = (await getCareerPagePaths()) ?? []

  return {
    paths: slugs,
    fallback: false
  }
}

export async function getStaticProps(context) {
  const data = (await FlexibleData.fetch(`careers/:id`)) ?? []
  const job = await getJob(context.params.id)

  return {
    props: { data, job }
  }
}

const JobPost = ({ data, job }) => {
  const meta = {
    pageTitle: job?.title,
    featuredImage: data?.featuredImage,
    excerpt: data?.excerpt
  }

  /* Use of <script> tag in <Head> is intentional here - see PR 959 */
  return (
    <>
      <Head>
        <script
          async
          src="https://boards.greenhouse.io/embed/job_board/js?for=amperity"
          onLoad="Grnhse.Iframe.autoLoad()"
        ></script>
      </Head>
      <FlexiblePage data={data} {...meta}></FlexiblePage>
    </>
  )
}

export default JobPost
